<template>
  <div>
   <Encabeza>
   </Encabeza>

    <v-card  class="mx-10 my-5 p-4">

      <!-- boton agregar uno nuevo -->
      <v-sheet  class="my-3">
        <v-btn variant="elevated" color="blue-darken-4" @click="newForm()"><v-icon
            icon="mdi-pencil-plus"></v-icon>&nbsp;Nuevo</v-btn>
      </v-sheet>
      <!-- Fin boton agregar uno nuevo -->

      <!-- buscador -->
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar registros" single-line hide-details
      >
      </v-text-field>
      <!-- fin buscador -->

      <v-data-table :headers="headers" :items="datos" :search="search" :items-per-page-options="items_per_page_options"
        class="mt-10" :hover="true" :fixed-header="true" :height="500" :show-current-page="true" :loading="change_table"
        :items-per-page-text="$t('$vuetify.dataTable.itemsPerPageText')"
        :no-data-text="$t('$vuetify.dataTable.noDataText')" page-text="{0}-{1} de {2}">
        <template v-slot:top>

          <FormCuchilloPage :dialog_parent="dialog_form" :registro_parent="item_armas_plus"
            @closeDialogParent="closeDialogForm()" :formTitleParent="formTitle" @saveParent="save()"
            :errors_validate_parent="errors_validate">
          </FormCuchilloPage>

          <FormCuchilloEditPage :dialog_parent="dialog_edit_form" :registro_parent="item_armas_plus_edit"
            @closeDialogParent="closeDialogForm()" :formTitleParent="formTitle" @saveParent="update()"
            :errors_validate_parent="errors_validate" persistent="false">
          </FormCuchilloEditPage>
          <v-snackbar v-model="snackbar_registers_enabled" :timeout="1000" location="top" min-height="70"
            :color="snackbar_color">
            <p>{{ snackbar_registers_message }}</p>
          </v-snackbar>

          <v-dialog v-model="dialog_delete" max-width="500px" persistent>
            <v-card>
              <v-card-text class="text-center">
                <v-icon class="as-scale" icon="mdi mdi-delete" size="100" color="red"></v-icon>
              </v-card-text>
              <p class="text-h4 text-center">
                ¿Esta seguro de eliminar este registro?
              </p>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" variant="elevated" @click="closeDialogDelete()">
                  <v-icon icon="mdi-file-cancel-outline"></v-icon>&nbsp;Cancelar</v-btn>
                <v-btn color="cyan-darken-3" variant="elevated" @click="deleteConfirm()">
                  <v-icon icon="mdi-content-save-check-outline"></v-icon>&nbsp;OK
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon @click="abrirDialogo(item)" class="m-1" color="orange-darken-2" icon="mdi-eye">
          </v-icon>
          <v-icon @click="editForm(item)" class="m-1" color="blue-darken-2" icon="mdi-pencil">
          </v-icon>
          <v-icon @click="deleteItem(item)" color="red" class="m-1" icon="mdi-delete">
          </v-icon>
        </template>

        <template v-slot:no-data>
          <v-btn color="success" @click="search = ''"> Reseter </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogoAbierto" max-width="500px">
      <v-card>
        <v-card-title> Contenido Individual </v-card-title>
        <v-card-text>
          <div><strong>ID: </strong> {{ codigo_dotacion }}</div>
          <div><strong>CARNET: </strong> {{ carnet }}</div>
          <div><strong># CUCHILLO: </strong> {{ nro_cuchillo }}</div>
          <div><strong>MARCA: </strong> {{ marca }}</div>z
          <div><strong>MODELO: </strong> {{ modelo }}</div>
          <div><strong>GESTION DOTACION: </strong> {{ gestion_dotacion }}</div>
          <div><strong>PROCEDENCIA: </strong> {{ procedencia }}</div>
          <div><strong>OBSERVACIONES: </strong> {{ observaciones }}</div>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cerrarDialogo">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { VDataTable } from "vuetify/labs/VDataTable";
import { defineComponent } from "vue";
import FormCuchilloPage from "@/components/cuchillos/FormCuchilloPage.vue";
import FormCuchilloEditPage from "@/components/cuchillos/FormCuchilloEditPage.vue";
import ArmaBlancaDotacion from "@/services/Armablanca";
import Encabeza from '@/components/EncabezadoPage.vue';


export default defineComponent({
  components: {
    VDataTable,
    FormCuchilloPage,
    FormCuchilloEditPage,
    Encabeza,
  },

  data() {
    const change_table = null;
    const obj_armas = new ArmaBlancaDotacion();
    const datos = [];
    const items_per_page_options = [
      { value: 10, title: "10" },
      { value: 25, title: "25" },
      { value: 50, title: "50" },
      { value: 100, title: "100" },
    ];
    const headers = [
      { title: '#', key: 'num' },
      { title: "Nombre", key: "nombre_completo" },
      { title: "Carnet", key: "carnet" },
      { title: "Cod Persona", key: "codigo_persona" },
      { title: "# Cuchillo", key: "nro_cuchillo" },
      { title: "Modelo", key: "modelo" },
      { title: "Procedencia", key: "procedencia" },
      { title: "Año Cuchillo", key: "gestion_dotacion" },
      { title: "Acciones", key: "actions", sortable: true, width: 150 },
    ];
    const default_item = {

    };
    const snackbar_registers_enabled = false;
    const snackbar_registers_message = "";
    const snackbar_color = "";
    const errors_validate = {};
    return {
      datos,
      obj_armas,
      change_table,
      dialog_form: false,
      dialog_edit_form: false,
      dialog_delete: false,
      search: "",
      headers,
      index_array: -1,
      item_armas_plus: "",
      item_armas_plus_edit: "",
      default_item,
      items_per_page_options,
      snackbar_registers_enabled,
      snackbar_registers_message,
      snackbar_color,
      errors_validate,
      dialogoAbierto: false,
      totalRegistros: 0,
    };
  },

  computed: {
    formTitle() {
      return this.index_array === -1 ? "Nuevo registro" : "Editar registro";
    },
  },

  mounted() {
    this.registros();
  },

  methods: {
    abrirDialogo(item) {
      if (item && item.codigo_dotacion) {
        this.codigo_dotacion = item.codigo_dotacion;
        this.carnet = item.carnet;
        this.codigo_persona = item.codigo_persona;
        this.nro_cuchillo = item.nro_cuchillo;
        this.marca = item.marca;
        this.modelo = item.modelo;
        this.gestion_dotacion = item.gestion_dotacion;
        this.procedencia = item.procedencia;
        this.observaciones = item.observaciones;
        this.dialogoAbierto = true;
      }
    },
    cerrarDialogo() {
      this.dialogoAbierto = false;
    },
    async registros() {
      this.change_table = "cyan";
      try {
        const response = await this.obj_armas.listadotacioncuchillo2();
        console.log("Este es mi response de servicio", response.records);

        if (response && response.status) {
          //this.datos = Object.values(response.records) || [];//funciona
          this.datos = Object.values(response.records).map((item, index) => {
            item.num = index + 1;
            return item;
          }) || [];
        } else {
          console.error("Respuesta inválida o sin registros.");
        }
      } catch (error) {
        console.error("Error al obtener los registros:", error);
      } finally {
        this.change_table = null;
      }
    },

    deleteItem(item) {
      if (item && typeof item.codigo_dotacion !== "undefined") {
        this.index_array = this.datos.indexOf(item);
        this.item_armas_plus = item;
        this.dialog_delete = true;
      } else {
        console.error("El registro no tiene un ID válido.");
      }
    },

    async deleteConfirm() {
      const armas_async = new ArmaBlancaDotacion();
      console.log("ID a eliminar:", this.item_armas_plus.codigo_dotacion); // Agregar esta línea para depurar
      const response = await armas_async.deleteRegistroCuchillo(
        this.item_armas_plus.codigo_dotacion
      );
      console.log("Respuesta de la eliminación:", response);
      if (response.status) {
        this.snackbar_registers_enabled = true;
        this.snackbar_color = "cyan-darken-3";
        this.snackbar_registers_message = response.message;
        this.datos.splice(this.index_array, 1);
      } else {
        this.snackbar_registers_enabled = true;
        this.snackbar_color = "red";
        this.snackbar_registers_message = "Error interno del servidor";
      }

      this.closeDialogDelete();
    },
    closeDialogDelete() {
      this.dialog_delete = false;
      this.clear();
    },
    closeDialogForm() {
      this.dialog_form = false;
      this.dialog_edit_form = false;
      this.clear();
    },
    clear() {
      this.$nextTick(() => {
        this.item_armas_plus = Object.assign({}, this.default_item);
        this.index_array = -1;
      });
      this.errors_validate = {};
    },

    newForm() {
      this.item_armas_plus = Object.assign({}, this.default_item);
      this.dialog_form = true;
    },
    async save() {
      const armas_async = new ArmaBlancaDotacion();
      if (this.item_armas_plus.id > 0) {
        Object.assign(this.datos[this.index_array], this.item_armas_plus);
      } else {
        const response = await armas_async.saveCuchillo(this.item_armas_plus);
        console.log("Este es el response", response);
        if (response && response.status) {
          //para actualizar la tabla .push
          this.datos.push(response.post);
          console.log("Estos son los datos del response",response.post);
          this.snackbar_color = "cyan-darken-3";
          this.snackbar_registers_enabled = true;
          this.snackbar_registers_message = response.message;
          //this.registros();
          this.closeDialogForm();
        } else {
          this.snackbar_color = "red";
          this.snackbar_registers_enabled = true;
        }
      }
    },
    editForm(item) {
      this.index_array = this.datos.indexOf(item);
      this.item_armas_plus_edit = Object.assign({}, item);
      this.dialog_edit_form = true;
    },
    async update() {
      try {
        const armas_async = new ArmaBlancaDotacion();
        const response = await armas_async.actualizarDotacionCuchillo(
          this.item_armas_plus_edit
        );
        console.log("Este es el response", response);

        if (response.status) {
          this.snackbar_color = "cyan-darken-3";
          this.snackbar_registers_enabled = true;
          this.snackbar_registers_message = response.message;
          this.closeDialogForm();
        } else {
          this.snackbar_color = "red";
          this.snackbar_registers_enabled = true;
        }
      } catch (error) {
        console.error("Error al actualizar el registro:", error);
      }
    },
  },
});
</script>
